// @ts-nocheck
import { types, getSnapshot, getEnv, flow, getParent } from "mobx-state-tree";
import { SingleChild } from "./children";
import LessonPaymentStore from "./lessonPayment";
import { determineTutorTotalPrice, rawTotalPrice } from "./utils/tutor-fns";
import SearchResultType from "./searchResult";

const SplitRequestStore:any = types
  .model("SplitRequestStore", {
    teacherOption: types.optional(types.string, ""),
    purposes: types.optional(
      types.array(types.maybe(types.maybeNull(types.string))),
      []
    ),
    class: types.optional(
      types.array(types.maybe(types.maybeNull(types.string))),
      []
    ),
    names: types.optional(types.array(types.string), []),
    specialNeeds: types.optional(
      types.array(types.optional(types.maybeNull(types.string), "")),
      []
    ),
    subjectGroup: types.optional(
      types.array(types.maybe(types.maybeNull(types.string))),
      []
    ),
    learningNeed: types.optional(
      types.array(
        types.union(types.maybe(types.string), types.maybeNull(types.string))
      ),
      []
    ),
    curriculum: types.optional(
      types.array(types.maybe(types.maybeNull(types.string))),
      []
    ),
    searchSubject: types.optional(
      types.maybe(types.maybeNull(types.string)),
      ""
    ),
    lessonDays: types.optional(
      types.array(types.maybe(types.maybeNull(types.string))),
      []
    ),
    lessonHours: types.optional(types.number, 0),
    forTeacher: types.optional(types.array(SingleChild), []),
    // selectedTutor: types.maybeNull(PreciseTutorInfo),
    tutorData: types.maybeNull(SearchResultType),
    tutorId: types.maybeNull(types.string),
    rawPaymentInfo: types.maybe(LessonPaymentStore),
    specialities: types.optional(
      types.array(types.maybe(types.maybeNull(types.string))),
      []
    ),
    lessonTime: types.optional(types.maybe(types.maybeNull(types.string)), ""),
    lessonDuration: types.optional(types.number, 0),
    lessonUrgency: types.optional(
      types.maybe(types.maybeNull(types.string)),
      ""
    ),
  })
  .views((self) => {
    return {
      get isBooked() {
        return false;
      },
      get requestInfo() {
        // students:
      },
      get lessonDetails() {
        return {
          lessonDays: getSnapshot(self.lessonDays),
          lessonHours: self.lessonHours,
          lessonDuration: self.lessonDuration,
          lessonUrgency: self.lessonUrgency,
          lessonTime: self.lessonTime,
        };
      },
      get individualTeacherArray() {
        return self.forTeacher.map((o) => ({
          ...getSnapshot(o),
          displayName: o.name || o.firstName,
        }));
      },
      get selectedTutor() {
        if (self.tutorId) {
          // console.log("Tutor id is ", self.tutorId);
          // console.log(self.tutorData.subject.name);
        }
        return self.tutorData;
      },
      get tutorBaseEarning() {
        if (self.tutorData) {
          let pricingInfo = self.tutorData.tutorPricingData;
          let { level, subject } = pricingInfo;
          let tutorPercent = level === "premium" ? 0.75 : 0.7;
          let lessonFee = self.rawPaymentInfo.lessonFee * tutorPercent;
          if (self.rawPaymentInfo) {
            return {
              tutor: pricingInfo,
              lessonFee,
              firstBookingDiscount: self.rawPaymentInfo.firstBookingDiscount,
              transportFare: self.rawPaymentInfo.transportFare,
              withholdingTax: 5,
              subject,
              level,
            };
          }
        }
        return {};
      },
      setNewRate(newRate, additionalInfo?: any) {
        if (self.tutorData) {
          self.tutorData.setNewRate(newRate, additionalInfo);
        }
      },
      rawCalculateTuition(hourlyRate, requestData) {
        let { lessonDetails } = requestData;
        let { lessonSchedule: oldLessonSchedule } = lessonDetails;
        let lessonSchedule = self.lessonDetails || this.lessonDetails;
        if (!lessonSchedule.lessonHours) {
          lessonSchedule.lessonHours = oldLessonSchedule.lessonHours;
        }
        if (lessonSchedule.lessonDays.length === 0) {
          lessonSchedule.lessonDays = oldLessonSchedule.lessonDays;
        }
        if (!lessonSchedule.lessonDuration) {
          lessonSchedule.lessonDuration = oldLessonSchedule.lessonDuration;
        }

        let lessonDuration = lessonSchedule
          ? lessonSchedule.lessonDuration
          : "";
        let lessonHours = lessonSchedule ? lessonSchedule.lessonHours : "";

        let { lessonDays, names: arrayOfStudents, selectedTutor: ost } = self;
        let selectedTutor = getSnapshot(ost);
        let priceInfo = rawTotalPrice(
          hourlyRate,
          selectedTutor.subject.discountForExtraStudents,
          {
            lessonHours,
            lessonDays: lessonDays.length,
            lessonDuration,
            numberOfStudents: arrayOfStudents.length,
          }
        );
        return Math.round(priceInfo);
      },
      get tutorAmount() {
        let parent = getParent(self, 2);
        console.log(parent.toJSON());
        let hourlyRate = self.tutorData
          ? self.tutorData.subject.hourlyRate || 0
          : 0;
        return hourlyRate
          ? self.rawCalculateTuition(hourlyRate, parent.requestData)
          : 0;
      },
      oldFlowLessonPayments(requestData, distanceThreshold, farePerKM) {
        let { selectedTutor: ost } = self;
        let selectedTutor = ost ? getSnapshot(ost) : {};
        let distanceFromClient = selectedTutor.distance || 0;
        let tutorName = selectedTutor.firstName;
        let priceInfo = {
          amount: selectedTutor.totalAmount,
          lessons: selectedTutor.lessons,
        };

        let transportCost = 0;

        let discount = 0;
        let hourlyRate = selectedTutor?.subject?.hourlyRate || 0;
        let hourlyDiscount = selectedTutor?.subject?.hourlyDiscount || 0;
        let discountForExtraStudents =
          selectedTutor?.subject?.discountForExtraStudents || 0;
        let tuteriaName = selectedTutor?.subject?.tuteriaName;
        let sname = selectedTutor?.subject?.name;
        return {
          // tutor: selectedTutor,
          tutor: {
            userId: selectedTutor.userId,
            subject: {
              hourlyRate,
              hourlyDiscount,
              discountForExtraStudents,
              tuteriaName,
              name: sname,
            },
            // subject: selectedTutor.subject.shortSummary,
            level: selectedTutor.level,
            newTutorDiscount: selectedTutor.newTutorDiscount,
            distance: selectedTutor.distance || 0,
            firstName: selectedTutor.firstName,
            lastName: selectedTutor.lastName,
            photo: selectedTutor.photo,
          },
          // students: priceInfo.students,
          lessons: priceInfo.lessons,
          // lessonRate: priceInfo.chargePerLesson,
          lessonFee: priceInfo.amount,
          // perStudentFee: priceInfo.tuitionPerStudent,
          // extraStudent: priceInfo.extraStudentTuition,
          firstBookingDiscount: discount,
          name: tutorName,
          distance: distanceFromClient,
          transportFare: transportCost,
        };
      },
      lessonPayments(
        requestData,
        distanceThreshold,
        farePerKM,
        isAdmin = false,
        index
      ) {
        let { lessonDetails, filters } = requestData;
        console.log("Lessson days", self.lessonDays.toJSON());
        let { lessonType } = lessonDetails;
        let { lessonSchedule: oldLessonSchedule } = lessonDetails;
        let lessonSchedule = self.lessonDetails || this.lessonDetails;
        if (!lessonSchedule.lessonHours) {
          lessonSchedule.lessonHours = oldLessonSchedule.lessonHours;
        }
        if (lessonSchedule.lessonDays.length === 0) {
          lessonSchedule.lessonDays = oldLessonSchedule.lessonDays;
        }
        if (!lessonSchedule.lessonDuration) {
          lessonSchedule.lessonDuration = oldLessonSchedule.lessonDuration;
        }
        let delivery = Boolean(filters.delivery)
          ? filters.delivery
          : lessonType;

        let lessonDuration = lessonSchedule
          ? lessonSchedule.lessonDuration
          : "";
        let lessonHours =
          self.lessonHours || lessonSchedule ? lessonSchedule.lessonHours : "";

        let { lessonDays, names: arrayOfStudents, selectedTutor: ost } = self;
        let selectedTutor = ost ? getSnapshot(ost) : {};
        let newTutorDiscount = selectedTutor.newTutorDiscount;
        let distanceFromClient = selectedTutor.distance || 0;
        let tutorName = selectedTutor.firstName;
        let billableDistance =
          delivery === "physical" && distanceFromClient > distanceThreshold
            ? distanceFromClient - distanceThreshold
            : 0;
        let priceInfo = determineTutorTotalPrice(selectedTutor, {
          lessonHours,
          lessonDays: lessonDays.length,
          lessonDuration,
          numberOfStudents: arrayOfStudents.length,
        });
        if (isAdmin) {
          if (selectedTutor.totalAmount > 0) {
            priceInfo.amount = selectedTutor.totalAmount;
            priceInfo.lessons = selectedTutor.lessons;
          }
        }

        let transportCost =
          priceInfo.students > 0
            ? billableDistance * farePerKM * 2 * priceInfo.lessons
            : 0;

        let discount =
          priceInfo.students > 0
            ? priceInfo.amount * (newTutorDiscount / 100)
            : 0;
        let hourlyRate = selectedTutor?.subject?.hourlyRate || 0;
        let hourlyDiscount = selectedTutor?.subject?.hourlyDiscount || 0;
        let discountForExtraStudents =
          selectedTutor?.subject?.discountForExtraStudents || 0;
        let tuteriaName = selectedTutor?.subject?.tuteriaName;
        let sname = selectedTutor?.subject?.name;
        return {
          // tutor: selectedTutor,
          tutor: {
            userId: selectedTutor.userId,
            subject: {
              hourlyRate,
              hourlyDiscount,
              discountForExtraStudents,
              tuteriaName,
              name: sname,
            },
            // subject: selectedTutor.subject.shortSummary,
            level: selectedTutor.level,
            newTutorDiscount: selectedTutor.newTutorDiscount,
            distance: selectedTutor.distance || 0,
            firstName: selectedTutor.firstName,
            lastName: selectedTutor.lastName,
            photo: selectedTutor.photo,
          },
          students: priceInfo.students,
          lessons: priceInfo.lessons,
          lessonRate: priceInfo.chargePerLesson,
          lessonFee: priceInfo.amount,
          perStudentFee: priceInfo.tuitionPerStudent,
          extraStudent: priceInfo.extraStudentTuition,
          firstBookingDiscount: discount,
          name: tutorName,
          distance: distanceFromClient,
          transportFare: transportCost,
        };
      },
    };
  })
  .actions((self) => {
    let { adapter } = getEnv(self);
    const addOrEditTutor = flow(function* addOrEditTutor(email) {
      let parent = getParent(self, 2);
      try {
        let result = yield parent.fetchTutor(email);
        self.tutorId = result.userId;
        self.tutorData = result;
      } catch (error) {
        throw error;
      }
    });
    const updateSplitInfo = (value) => {
      if (Object.keys(value).includes("lessonHours")) {
        let v = value.lessonHours.trim().split(" ")[0];
        self.lessonHours = parseFloat(v) || 0;
      } else if (Object.keys(value).includes("lessonTime")) {
        let v = value.lessonTime.trim().replace("Time: ", "");
        self.lessonTime = v;
      }
      console.log(value);
    };
    const onSave = flow(function* onSave() {
      let parent = getParent(self, 2);
      yield parent.saveRequestInfo();
    });
    const updateTutorHourlyRate = flow(
      function* updateTutorHourlyRate(value, index) {
        if (self.tutorData) {
          self.tutorData.setNewRate(parseFloat(value));
          console.log(value);
        }
      }
    );
    const addTutorToPool = flow(function* addTutorToPool(subject) {
      let parent = getParent(self, 3);
      console.log(parent.toJSON());
      yield parent.addTutorToPool(self.tutorData.email, subject);
    });
    return {
      addOrEditTutor,
      onSave,
      updateTutorHourlyRate,
      updateSplitInfo,
      addTutorToPool,
    };
  });

export default SplitRequestStore;
